import { AuditionFormValue } from 'commons/auditionForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { FC } from 'react';

type AnswerProps = {
  value: AuditionFormValue;
};
export const Answer: FC<AnswerProps> = ({ value }) => {
  const { t } = useTranslationWithLang('auditionForm');
  const className = 'text-lg mb-4 whitespace-pre-wrap';
  if (value.answer === '') {
    return <p className={`${className} text-[--c-text2]`}>{t('TU002_116')}</p>;
  }
  return (
    <>
      {typeof value.answer !== 'string' ? (
        value.answer.file instanceof File ? (
          <p className={className}>{value.answer.file.name}</p>
        ) : (
          Array.from(value.answer.file).map((file) => {
            console.log('file');
            return <p className={className}>{file.name}</p>;
          })
        )
      ) : (
        <p className={className}>{value.answer}</p>
      )}
    </>
  );
};
